export enum PlayerZone {
	Unknown,
	China,
	Japan,
	Other
}
